export default {
  yellow: "#FFD340",
  green: "#A7CF3E",
  red: "#D13838",
  white: "#fff",
};
